module.exports = __webpack_public_path__ + "static/media/plumber.00e957d5.jpeg";